import { RefObject, useEffect } from "react";

// DEBUG soucis quand on doit resize back
const handleRezise = (textArea: HTMLTextAreaElement) => {
  const scrollHeight = textArea.scrollHeight;
  textArea.style.height = scrollHeight + "px";
};
const useAutosizeTextArea = (textAreaRef: RefObject<HTMLTextAreaElement | null>, value: string | null, club: unknown) => {
  const textAreaElement = textAreaRef.current;
  useEffect(() => {
    const resizeListener = () => {
      return handleRezise(textAreaRef.current!);
    };
    if (textAreaRef.current && club) {
      window.addEventListener("resize", resizeListener);
      setTimeout(() => {
        const textArea = textAreaRef.current!;
        textArea.style.height = "0px";
        textArea.style.overflow = "auto";
        const scrollHeight = textArea.scrollHeight;
        textArea.style.height = scrollHeight + "px";
      }, 1);
    }
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [club, textAreaRef, textAreaElement]);
};
export default useAutosizeTextArea;